import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Avatar, Divider } from "@mui/material";
import "./GovtTaxARModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";
import CompDirection from "../../../themes/CompDirection";
import LinearProgress from "@mui/material/LinearProgress";
import { themes } from "../../../themes/themes";
import TakeActionSplitBtn from "../../../components/TakeActionSplitBtn/TakeActionSplitBtn";
import LeaveHistoryArTile from "../../../components/LeaveHistoryTileAr/LeaveHistoryTileAr";
import LeaveInsightArTile from "../../../components/LeaveInsightArTile/LeaveInsightArTile";
import HorizontalStepperForActionRequired from "../../../components/HorizontalStepperForActionRequired/HorizontalStepperForActionRequired";
import EmployeeTicketHistoryARTile from "../../../components/EmployeeTicketHistoryARTile/EmployeeTicketHistoryARTile";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
}

const GovtTaxARModalPresenter = ({
  isModalOpen,
  closeModal,

  trans,
}: ModalProps) => {
  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="35vw">
      <ModalHeader
        modal={{ modal_title: trans("Govt Tax Action Required") }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: "5px",
          }}
        >
          <Grid item xs={6}>
            <Box className="bg_border_ar">
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Avatar />
                <Box style={{ paddingLeft: "10px" }}>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      color: themes.darkBlue,
                      fontSize: "1em",
                      fontWeight: "bold",
                    }}
                  >
                    Amellia Russel
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      color: themes.grey_colorDesignationAR,
                      fontSize: "0.825em",
                    }}
                  >
                    Development / UX Designer
                  </Typography>
                </Box>
              </Box>

              <Box
                style={{
                  padding: "1em",
                  border: "1px solid #0000001f",
                  borderRadius: "10px",
                  marginTop: "1em",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "0.7em",
                      color: themes.greyDefault_500,
                      border: "1px solid #9E9E9E",
                      borderRadius: "4px",
                      padding: "4px",
                      alignSelf: "center",
                    }}
                  >
                    {" "}
                    PF
                  </Typography>{" "}
                  <Typography>
                    <i
                      className="las la-ellipsis-h"
                      color={themes.greyDefault_500}
                      style={{ height: "1em", width: "1em" }}
                    />
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    padding: "1em",
                    marginTop: "0.5em",
                    width: "auto",
                    backgroundColor: "#F5F5FA66",
                    height: "auto",
                    borderRadius: "10px",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "0.5em",
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.7em",
                        color: themes.greyModalTitle,
                      }}
                    >
                      Tax For
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.7em",
                        color: themes.greyModalTitle,
                      }}
                    >
                      Value
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "5px",
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.7em",
                        color: "#21D8A5",
                      }}
                    >
                      Employee
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.7em",
                        fontWeight: "bold",
                        color: themes.lightRedSubtittle,
                      }}
                    >
                      12%
                    </Typography>
                  </Box>
                  <Divider style={{ marginTop: "0.5em" }} />
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "0.5em",
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.7em",
                        color: themes.greyModalTitle,
                      }}
                    >
                      Salary Range
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.7em",
                        color: themes.greyModalTitle,
                      }}
                    >
                      Applicable For
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "5px",
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.725em",
                        fontWeight: "bold",
                        color: themes.darkBlue,
                      }}
                    >
                      AED (0-12000)
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.725em",
                        fontWeight: "bold",
                        color: themes.darkBlue,
                      }}
                    >
                      Basic , HRA
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                style={{
                  padding: "1em",
                  border: "1px solid #0000001f",
                  borderRadius: "10px",
                  marginTop: "1em",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "0.7em",
                      color: themes.greyDefault_500,
                      border: "1px solid #9E9E9E",
                      borderRadius: "4px",
                      padding: "4px",
                      alignSelf: "center",
                    }}
                  >
                    {" "}
                    ESI
                  </Typography>{" "}
                  <Typography>
                    <i
                      className="las la-ellipsis-h"
                      color={themes.greyDefault_500}
                      style={{ height: "1em", width: "1em" }}
                    />
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    padding: "1em",
                    marginTop: "0.5em",
                    width: "auto",
                    backgroundColor: "#F5F5FA66",
                    height: "auto",
                    borderRadius: "10px",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "0.5em",
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.7em",
                        color: themes.greyModalTitle,
                      }}
                    >
                      Tax For
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.7em",
                        color: themes.greyModalTitle,
                      }}
                    >
                      Value
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "5px",
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.7em",
                        color: "#21D8A5",
                      }}
                    >
                      Employer
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.7em",
                        fontWeight: "bold",
                        color: themes.lightRedSubtittle,
                      }}
                    >
                      AED 300
                    </Typography>
                  </Box>
                  <Divider style={{ marginTop: "0.5em" }} />
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "0.5em",
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.7em",
                        color: themes.greyModalTitle,
                      }}
                    >
                      Salary Range
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.7em",
                        color: themes.greyModalTitle,
                      }}
                    >
                      Applicable For
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "5px",
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.725em",
                        fontWeight: "bold",
                        color: themes.darkBlue,
                      }}
                    >
                      AED (0-12000)
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "0.725em",
                        fontWeight: "bold",
                        color: themes.darkBlue,
                      }}
                    >
                      Basic , HRA
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          {/* {Second Column} */}
          <Grid item xs={6}>
            <Box className="bg_border_ar">
              <Box>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: "1.5em", zIndex: "999", width: "100%" }}>
                <TakeActionSplitBtn
                  onSelect={() => alert(1)}
                  menu={[{ id: 1, label: "a" }]}
                  title={"Take Action"}
                />
              </Box>
            </Box>
          </Grid>

          {/* {Horizontals Steps Label} */}
          <Grid item xs={12}>
            <Box
              style={{
                border: "1px solid #0000001f",
                padding: "10px",
                borderRadius: "10px",
              }}
            >
              <HorizontalStepperForActionRequired direction="horizontal" />
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default GovtTaxARModalPresenter;
